<style>

.faq .section-shaped .shape-style-1.shape-primary.wsu {
    /* uigradients.com */
    background: #042D98;
    background-image: url('./../assets/img/vortex.jpg');
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    -webkit-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
}

.faq .title {
    color: #ffffff;
}

.faq .subtitle {
    color: #e0e1e2;
}

.faq .faq-body {
    min-height: 700px;
}

.faq .loading {
    background-color: #f7f7f7;
}

.faq .link {
    cursor: pointer;
}

/*

Accordion__header

*/

.faq .badger-accordion__header {
    border-bottom: 1px solid #EFF1F0;
}

.faq .js-badger-accordion-header {
    align-content: space-between;
    align-items: center;
    background-color: #fff;
    border: 0;
    border-radius: 0px;
    color: #333333;
    display: flex;
    font-family: 'Josefin Sans', Arial;
    font-size: 1.25rem;
    line-height: 1;
    padding: 20px;
    text-align: left;
    transition: all ease-in-out .2s;
    width: 100%;
    font-weight: bold;
}

.faq .js-badger-accordion-header i.fa {
    font-size: 2rem;
    font-weight: normal;
}

.faq .badger-accordion__panel {
    background-color: #fafafa;
    position: relative;
}

.faq .js-badger-accordion-panel-inner {
    padding: 20px 20px 40px;
}

.faq .js-badger-accordion-header:focus, .js-badger-accordion-header:hover {
    background-color: #042D98;
    cursor: pointer;
    outline: none;
    color: #fff;
}

.faq .badger-accordion__trigger:hover .badger-accordion__trigger-title {
}

/*

Fim Accordion__header

*/

@media(max-width:575px) {}

@media(min-width:576px) and (max-width:767px) {}

@media(min-width:768px) and (max-width:991px) {}

@media(min-width:992px) and (max-width:1199px) {}

@media(min-width:1200px) {}

</style>

<template>

<div class="faq">
    <section class="section section-shaped my-0 pb-xs">
        <div class="shape shape-style-1 shape-primary wsu">
        </div>
        <div class="container">
            <div class="row my-0 py-0">
                <div class="col-lg-12">
                    <h1 class="title text-center my-0 py-0"><center>EDUCATIONAL DATABASE</center></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2">&nbsp;</div>
                <div class="col-lg-8">
                    <p class="subtitle" v-html="subtitle"></p>
                </div>
            </div>
        </div>
    </section>
    <section class="section faw-body">
        <div class="container">
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading">
                    <h1>FAQ</h1>
                    <span class="text-uppercase text-primary">{{title}}</span>
                </div>
                <div class="col-lg-8 loading" v-if="loading">
                    <h1>&nbsp;</h1>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading" v-html="description"></div>
                <div class="col-lg-8 loading" v-if="loading">
                    <template v-for="i in (1, 8)">
                        <p>&nbsp;</p>
                    </template>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading">
                    <badger-accordion :icons="{opened: faDown, closed: faUp}">
                        <template v-for="faq in faqs">
                            <badger-accordion-item>
                              <template slot="header">{{faq.title}}</template>
                              <template slot="content"><div v-html="faq.description"></div></template>
                            </badger-accordion-item>
                        </template>
                    </badger-accordion>
                </div>
            </div>
        </div>
    </section>
</div>

</template>

<script>

import axios from 'axios'
import {
    BadgerAccordion, BadgerAccordionItem
}
from 'vue-badger-accordion'

export default {
    components: {
        BadgerAccordion,
        BadgerAccordionItem
    },
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        if(this.$store.state.subtitle_store)
            this.subtitle = this.$store.state.subtitle_store
        else this.get_page_subtitle()
        this.get_page()
        this.get_faq()
    },
    methods: {
        get_page_subtitle() {
            this.error = null
            axios.get(this.api + 'page/subtitle-pages')
                .then(response => {
                    this.subtitle = response.data.content
                    this.$store.state.subtitle_store = this.subtitle
                })
        },
        get_page() {
                this.error = null
                this.loading = true
                axios.get(this.api + 'page/faq')
                    .then(response => {
                        this.loading = false
                        this.title = response.data.title
                        this.description = response.data.content
                        document.getElementsByTagName('meta')["description"].content = this.description.substr(0, 150);
                    })
            },
            get_faq() {
                this.error = null
                this.loading_faq = true
                axios.get(this.api + 'faqs')
                    .then(response => {
                        this.loading_faq = false
                        this.faqs = response.data || []
                    })
            }
    },
    head: {
        title: function () {
          return {
            inner: 'FAQ'
          }
        }
    },
    data() {
        return {
            api: require('../../package.json').api,
            subtitle: '',
            error: null,
            loading: false,
            loading_faq: false,
            title: '',
            description: '',
            faqs: null,
            faDown: '<i class="fa fa-chevron-down"></i>',
            faUp: '<i class="fa fa-chevron-up"></i>'
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/Faq.vue